<template>
  <el-card
    class="cash-not-account business-handling my-card"
    :body-style="cardBody"
  >
    <el-page-header @back="$router.go(-1)" :title="$t('Back')">
      <template slot="content"
        ><span style="font-size:14px"
          >{{ $t("remittanceBusiness") }} / {{ $t("cashNotAccount") }}</span
        ></template
      >
    </el-page-header>
    <div class="form-container">
      <el-form
        ref="remitterForm"
        :model="remitterForm"
        :rules="rules"
        label-position="top"
      >
        <el-divider content-position="left">{{
          $t("remitterInfo")
        }}</el-divider>
        <el-row :gutter="20">
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('firstName')" prop="remittorName">
              <el-input
                size="medium"
                v-model="remitterForm.remittorName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('lastName')" prop="remittorSurname">
              <el-input
                size="medium"
                v-model="remitterForm.remittorSurname"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('phone')" prop="remittorPhone">
              <el-input
                size="medium"
                v-model="remitterForm.remittorPhone"
                @input="handlePhoneInput"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('idNumber')" prop="remittorIdCard">
              <el-input
                size="medium"
                v-model="remitterForm.remittorIdCard"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('post')" prop="remittorPost">
              <el-input
                size="medium"
                v-model="remitterForm.remittorPost"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">{{
          $t("beneficiaryInfo")
        }}</el-divider>
        <el-row :gutter="20">
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('firstName')" prop="payeeName">
              <el-input
                size="medium"
                v-model="remitterForm.payeeName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('lastName')" prop="payeeSurname">
              <el-input
                size="medium"
                v-model="remitterForm.payeeSurname"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('phone')" prop="payeePhone">
              <el-input
                size="medium"
                v-model="remitterForm.payeePhone"
                @input="handlePhoneInputPayee"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('idNumber')">
              <el-input
                size="medium"
                v-model="remitterForm.payeeIdCard"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item
              :label="$t('beneficiaryAddress')"
              prop="country_region_city"
            >
              <el-cascader
                size="medium"
                v-model="remitterForm.country_region_city"
                :options="countryTree"
                :props="cascader"
              ></el-cascader>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('post')" prop="payeePost">
              <el-input
                size="medium"
                v-model="remitterForm.payeePost"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-divider content-position="left">{{
          $t("remittanceInfo")
        }}</el-divider>
        <el-row :gutter="20">
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('remittanceAmount')" prop="amount">
              <el-input
                size="medium"
                v-model="remitterForm.amount"
                @blur="calculateServiceCharge"
                @input="
                  remitterForm.amount = remitterForm.amount.formatMoney(0, ' ')
                "
                :disabled="isCompute"
              >
                <template slot="prepend"
                  ><i
                    class="iconfont iconruishifalang"
                    style="font-size:14px"
                  ></i>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item
              :label="
                $t('serviceCharge') +
                  ' ' +
                  (isCompute ? $t('calculating') + '……' : '')
              "
              prop="serviceChargeAmount"
            >
              <el-input
                type="number"
                size="medium"
                v-model="remitterForm.serviceChargeAmount"
                @input="
                  remitterForm.serviceChargeAmount = remitterForm.serviceChargeAmount.formatMoney(
                    0,
                    ' ',
                  )
                "
                disabled
                :placeholder="
                  $t('AfterEnteringTheAmountItWillBAutomaticallyCalculated')
                "
              >
                <template slot="prepend"
                  ><i
                    class="iconfont iconruishifalang"
                    style="font-size:14px"
                  ></i>
                </template>
              </el-input>
            </el-form-item>
          </el-col>

          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('Service fee discount2')" prop="coupon">
              <el-input
                size="medium"
                v-model="remitterForm.coupon"
                @input="
                  remitterForm.coupon = remitterForm.coupon.formatMoney(0, ' ')
                "
                type="number"
              >
                <template slot="prepend"
                  ><i
                    class="iconfont iconruishifalang"
                    style="font-size:14px"
                  ></i>
                </template>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item
              :label="$t('serviceCharge') + $t('payment')"
              prop="payServiceChargeType"
            >
              <el-select
                size="medium"
                v-model="remitterForm.payServiceChargeType"
              >
                <el-option
                  :label="$t('remitterPayment')"
                  :value="0"
                ></el-option>
                <el-option :label="$t('payeePayment')" :value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <transaction-tax-display
              businessCode="20"
              :transaction-amount="remitterForm.amount"
            ></transaction-tax-display>
          </el-col>
          <el-col :md="8" :lg="6" :xl="4">
            <el-form-item :label="$t('remittance reason')" prop="purpose">
              <el-select size="medium" v-model="remitterForm.purpose">
                <el-option
                  :label="$t('School aid')"
                  :value="$t('School aid')"
                ></el-option>
                <el-option
                  :label="$t('Family assistance')"
                  :value="$t('Family assistance')"
                ></el-option>
                <el-option
                  :label="$t('Building construction')"
                  :value="$t('Building construction')"
                ></el-option>
                <el-option
                  :label="$t('Business settlement')"
                  :value="$t('Business settlement')"
                ></el-option>
                <el-option
                  :label="$t('Service settlement')"
                  :value="$t('Service settlement')"
                ></el-option>
                <el-option
                  :label="$t('Debt repayment')"
                  :value="$t('Debt repayment')"
                ></el-option>

                <el-option
                  :label="$t('Savings group')"
                  :value="$t('Savings group')"
                ></el-option>

                <el-option
                  :label="$t('Medical expenses')"
                  :value="$t('Medical expenses')"
                ></el-option>

                <el-option
                  :label="$t('Salary')"
                  :value="$t('Salary')"
                ></el-option>

                <el-option
                  :label="$t('Solidarity fund')"
                  :value="$t('Solidarity fund')"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-col :span="12">
              <el-form-item :label="$t('remark')">
                <el-input
                  size="medium"
                  type="textarea"
                  v-model="remitterForm.remark"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- Bottom button to trigger validation -->
    <div class="bottom-button">
      <el-button
        v-if="!printParam"
        :loading="isLoading"
        size="medium"
        type="primary"
        @click="validateForm('remitterForm')"
        >{{ $t("submit") }}</el-button
      >
      <el-button v-else size="medium" @click="printVisible = true">{{
        $t("printrRceipt")
      }}</el-button>
    </div>
    <!-- Dialog for data validation -->
    <el-dialog
      :title="$t('Validate Remittance Data')"
      :visible.sync="validationDialogVisible"
      width="600px"
    >
      <el-row :gutter="20">
        <el-col :span="12">
          <el-row>
            <el-col :span="24">
              <strong>{{ $t("remitterInfo") }}</strong>
            </el-col>
            <el-col :span="24">
              <label>{{ $t("firstName") }}:</label>
              {{ remitterForm.remittorName }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("lastName") }}:</label>
              {{ remitterForm.remittorSurname }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("phone") }}:</label> {{ remitterForm.remittorPhone }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("idNumber") }}:</label>
              {{ remitterForm.remittorIdCard }}
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="12">
          <el-row>
            <el-col :span="24">
              <strong>{{ $t("beneficiaryInfo") }}</strong>
            </el-col>
            <el-col :span="24">
              <label>{{ $t("firstName") }}:</label> {{ remitterForm.payeeName }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("lastName") }}:</label>
              {{ remitterForm.payeeSurname }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("phone") }}:</label> {{ remitterForm.payeePhone }}
            </el-col>
            <el-col :span="24">
              <label>{{ $t("idNumber") }}:</label>
              {{ remitterForm.payeeIdCard }}
            </el-col>

            <el-col :span="24">
              <label>{{ $t("beneficiaryAddress") }}:</label>
              {{ formatRegionPays(countryRegionCity) }}
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <el-row :gutter="20" style="margin-top: 20px;">
        <el-col :span="24">
          <strong>{{ $t("remittanceInfo") }}</strong>
        </el-col>
        <el-col :span="12">
          <label>{{ $t("remittanceAmount") }}:</label>
          {{ (remitterForm.amount || 0).formatMoney(0) }}
        </el-col>
        <el-col :span="24">
          <label>{{ $t("serviceCharge") }}:</label>
          {{ (remitterForm.serviceChargeAmount || 0).formatMoney(0) }}
        </el-col>
        <el-col :span="12">
          <label>{{ $t("Service fee discount") }}:</label>
          {{ (remitterForm.coupon || 0).formatMoney(0) }}
        </el-col>
        <el-col :span="24">
          <label>{{ $t("serviceCharge") + $t("payment") }}:</label>
          {{
            remitterForm.payServiceChargeType === 0
              ? $t("Remitter Payment")
              : $t("Payee Payment")
          }}
        </el-col>

        <el-col :span="24">
          <label>{{ $t("remittance reason") }}:</label>
          {{ remitterForm.purpose }}
        </el-col>
        <el-col :span="24">
          <label>{{ $t("remark") }}:</label> {{ remitterForm.remark }}
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="validationDialogVisible = false">{{
          $t("Cancel")
        }}</el-button>
        <el-button type="primary" @click="submit('remitterForm')">{{
          $t("Confirm and Submit")
        }}</el-button>
      </span>
    </el-dialog>

    <!-- Existing dialog-->
    <el-dialog
      :title="$t('printrRceipt')"
      :visible.sync="printVisible"
      width="500px"
      :modal-append-to-body="false"
      :destroy-on-close="true"
      :close-on-press-escape="false"
      :close-on-click-modal="false"
    >
      <print-credentials
        :param="printParam"
        :isClosePrint.sync="printVisible"
      />
    </el-dialog>
  </el-card>
</template>

<script>
import printCredentials from "@/components/printCredentials";
import transactionInfo from "@/api/transactionInfo";
import TransactionTaxDisplay from "@/components/TransactionTaxDisplay";
import business from "@/api/business";
import transactionDetails from "@/api/transactionDetails";
import { debounce } from "lodash";
//import manba from "@/assets/uilt/manbaDate";

export default {
  components: { printCredentials, TransactionTaxDisplay },
  data() {
    return {
      isLoading: false,
      remitterForm: { coupon: 0 },
      payeeForm: {},
      remitterRecords: new Array(),
      payeeRecords: new Array(),
      isCompute: false,

      printVisible: false,
      printParam: null,

      countryRegionCity: "",

      validationDialogVisible: false,
    };
  },

  computed: {
    cascader() {
      return this.$store.state.format.cascader;
    },
    cardBody() {
      return this.$store.state.style.cardBody;
    },
    rules() {
      return {
        remittorName: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        remittorSurname: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        remittorPhone: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        //remittorIdCard: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
        payeeName: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        payeeSurname: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        payeePhone: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        payeeIdCard: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        serviceChargeAmount: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        payServiceChargeType: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        purpose: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
        country_region_city: [
          {
            required: true,
            message: this.$t("requiredFields"),
            trigger: "blur",
          },
        ],
      };
    },
    countryTree() {
      return this.$store.state.globalParameter.countryTree;
    },
    countryList() {
      return this.$store.state.globalParameter.countryList;
    },
  },
  watch: {
    printVisible(val) {
      if (!val && this.printParam) {
        this.$router.replace({ name: "businessHandling" }).then(() => {
          this.$router.go(0);
        });
      }
    },
    /**手续费优惠输入金额后计算优惠后的手续费 */
    "remitterForm.coupon"(newValue) {
      /**优惠手续费金额不能是负数 */
      if (newValue < 0) {
        this.remitterForm.coupon = 0;
        return;
      }
      /**优惠后手续费不能是负数 */
      if (this.remitterForm.purposeBefore - this.remitterForm.coupon < 0) {
        this.remitterForm.coupon = 0;
        return;
      }

      this.$set(
        this.remitterForm,
        "serviceChargeAmount",
        this.remitterForm.purposeBefore - this.remitterForm.coupon,
      );
    },
    /*
    "remitterForm.amount"(newValue) {
      if (newValue < 0) this.remitterForm.amount = 0;
    },*/

    "remitterForm.amount"(newValue) {
      if (newValue < 0) this.remitterForm.amount = 0;
      this.$set(this.remitterForm, "serviceChargeAmount", undefined);
      this.$set(this.remitterForm, "purposeBefore", undefined);
    },

    phone(newPhone) {
      this.fetchTransactionDetails(newPhone);
    },
  },
  methods: {
    handlePhoneInput: debounce(function() {
      // Adjust length based on your requirement
      let _this = this;
      if (_this.remitterForm.remittorPhone.length < 8) {
        this.$set(this.remitterForm, "remittorName", "");
        this.$set(this.remitterForm, "remittorSurname", "");
        this.$set(this.remitterForm, "remittorIdCard", "");

        this.$set(this.remitterForm, "remittorPost", "");
        //this.$set(this.remitterForm, "remittorDateOfBirth", "");
        //this.$set(this.remitterForm, "remittorPlaceOfBirth", "");
      } else {
        this.getRemitterRecords("remitterForm");
      }
    }, 200),

    handlePhoneInputPayee: debounce(function() {
      // Adjust length based on your requirement
      let _this = this;
      if (_this.remitterForm.payeePhone.length < 8) {
        // for payee
        this.$set(this.remitterForm, "payeeName", "");
        this.$set(this.remitterForm, "payeeSurname", "");
        this.$set(this.remitterForm, "payeeIdCard", "");

        this.$set(this.remitterForm, "payeePost", "");
        //this.$set(this.remitterForm, "payeeDateOfBirth", "");
        //this.$set(this.remitterForm, "payeePlaceOfBirth", "");
      } else {
        this.getPayeeRecords("remitterForm");
      }
    }, 200),

    getRemitterRecords(refName) {
      let _this = this;
      let p = {};
      p.phone = _this[refName].remittorPhone;

      transactionDetails.getByPhoneAndIdCard({
        param: p,
        success: (res) => {
          if (res.code == 200) {
            if (Array.isArray(res.data) && res.data.length > 0) {
              const firstTransaction = res.data[0];

              // Update form fields reactively

              this.$set(
                this.remitterForm,
                "remittorName",
                firstTransaction.name,
              );
              this.$set(
                this.remitterForm,
                "remittorSurname",
                firstTransaction.surname,
              );
              this.$set(
                this.remitterForm,
                "remittorIdCard",
                firstTransaction.idCard,
              );

              this.$set(
                this.remitterForm,
                "remittorPost",
                firstTransaction.post,
              );
              /*this.$set(
                this.remitterForm,
                "remittorDateOfBirth",
                firstTransaction.dateOfBirth
              );
              this.$set(
                this.remitterForm,
                "remittorPlaceOfBirth",
                firstTransaction.placeOfBirth
              );*/

              //console.log("Data ", firstTransaction.name, " ", firstTransaction.post)
            } else {
              // Update form fields reactively
              this.$set(this.remitterForm, "remittorName", "");
              this.$set(this.remitterForm, "remittorSurname", "");
              this.$set(this.remitterForm, "remittorIdCard", "");

              this.$set(this.remitterForm, "remittorPost", "");
              //this.$set(this.remitterForm, "remittorDateOfBirth", "");
              //this.$set(this.remitterForm, "remittorPlaceOfBirth", "");

              _this.$message.warning(_this.$t("no data"));
            }
          } else {
            // Update form fields reactively
            this.$set(this.remitterForm, "remittorName", "");
            this.$set(this.remitterForm, "remittorSurname", "");
            this.$set(this.remitterForm, "remittorIdCard", "");

            this.$set(this.remitterForm, "remittorPost", "");
            //this.$set(this.remitterForm, "remittorDateOfBirth", "");
            //this.$set(this.remitterForm, "remittorPlaceOfBirth", "");

            _this.$message.warning(_this.$t(res.msg));
          }
        },
      });

      /**transactionDetails.getByPhoneAndIdCard({
            param: p,
            success: res => {
              if (res.code == 200) {
                _this.remitterForm.remittorName = res.data.name;
                _this.remitterForm.remittorSurname = res.data.surname;

                console.log("Name: "+ res.data.name);     
              }
              else{
                _this.$message.warning(_this.$t(res.msg));
                return;
              }  
            }
          });*/
    },
    getPayeeRecords(refName) {
      let _this = this;
      let p = {};
      p.phone = _this[refName].payeePhone;

      transactionDetails.getByPhoneAndIdCard({
        param: p,
        success: (res) => {
          if (res.code == 200) {
            if (Array.isArray(res.data) && res.data.length > 0) {
              const firstTransaction = res.data[0];

              this.$set(this.remitterForm, "payeeName", firstTransaction.name);
              this.$set(
                this.remitterForm,
                "payeeSurname",
                firstTransaction.surname,
              );
              this.$set(
                this.remitterForm,
                "payeeIdCard",
                firstTransaction.idCard,
              );

              this.$set(this.remitterForm, "payeePost", firstTransaction.post);
              this.$set(
                this.remitterForm,
                "payeeDateOfBirth",
                firstTransaction.dateOfBirth,
              );
              this.$set(
                this.remitterForm,
                "payeePlaceOfBirth",
                firstTransaction.placeOfBirth,
              );
            } else {
              // Update form fields reactively
              this.$set(this.remitterForm, "payeeName", "");
              this.$set(this.remitterForm, "payeeSurname", "");
              this.$set(this.remitterForm, "payeeIdCard", "");

              this.$set(this.remitterForm, "payeePost", "");
              this.$set(this.remitterForm, "payeeDateOfBirth", "");
              this.$set(this.remitterForm, "payeePlaceOfBirth", "");

              _this.$message.warning(_this.$t("no data"));
            }
          } else {
            // Update form fields reactively
            this.$set(this.remitterForm, "payeeName", "");
            this.$set(this.remitterForm, "payeeSurname", "");
            this.$set(this.remitterForm, "payeeIdCard", "");

            this.$set(this.remitterForm, "payeePost", "");
            this.$set(this.remitterForm, "payeeDateOfBirth", "");
            this.$set(this.remitterForm, "payeePlaceOfBirth", "");

            _this.$message.warning(_this.$t(res.msg));
          }
        },
      });
    },
    calculateServiceCharge() {
      let _this = this;
      if (!_this.remitterForm.amount) {
        _this.$set(_this.remitterForm, "serviceChargeAmount", undefined);
        return;
      }
      _this.isCompute = true;
      business.serviceChargeCompute({
        param: {
          amount: _this.remitterForm.amount,
          businessCode: _this.$route.params.code,
        },
        success: (res) => {
          setTimeout(() => {
            if (res.code != 200) _this.$message.warning(_this.$t(res.msg));
            /**手续费 */
            _this.$set(
              _this.remitterForm,
              "serviceChargeAmount",
              res.data || 0,
            );
            /**手续费优惠金额 */
            _this.$set(_this.remitterForm, "purposeBefore", res.data || 0);
            _this.isCompute = false;
          }, 500);
        },
      });
    },

    formatRegionPays2(region) {
      let p13 = this.countryList.find(function(c) {
        return c.id == region;
      });
      let p2 = this.countryList.find(function(c) {
        return c.id == p13.parentId;
      });
      return p2.name + "/" + p13.name;
    },
    formatRegionPays(region) {
      if (!region) return "";
      // Find the parent country in the countryList
      let p2 = this.countryList.find((c) => c.id == region);
      if (!p2) return ""; // Handle case where parent country is not found
      //console.log(p2.name);
      return p2.name; // Return the parent country name
    },
    // Validate the form and open the validation dialog
    validateForm(refName) {
      let _this = this;
      this.$refs[refName].validate((valid) => {
        if (valid) {
          this.validationDialogVisible = true;
          this.countryRegionCity = _this[refName].country_region_city[2]; // Open the validation dialog
        } else {
          return false; // Stop if the form is invalid
        }
      });
    },

    // Submit the form data to the backend
    submit(refName) {
      let _this = this;
      this.$refs[refName].validate((valid) => {
        if (valid) {
          _this.isLoading = true;
          _this[refName].payeeCountryId = _this[refName].country_region_city[0];
          _this[refName].payeeRegionId = _this[refName].country_region_city[1];
          _this[refName].payeeCityId = _this[refName].country_region_city[2];
          _this[refName].businessCode = _this.$route.params.code;

          transactionInfo.cashRemittance({
            param: _this[refName],
            success: (res) => {
              if (res.code == 200) {
                _this.$message.success(_this.$t("operateSuccessfully"));

                _this.$set(_this, "printParam", res.data);
                _this.$set(_this, "printVisible", true);
              } else {
                _this.$message.warning(_this.$t(res.msg));
              }
              _this.isLoading = false;
              _this.validationDialogVisible = false;
            },
          });
        } else return false;
      });
    },
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
.cash-not-account.business-handling {
  height: 100%;
  width: 100%;
  .el-card__body {
    position: relative;
    .form-container {
      position: absolute;
      top: 50px;
      bottom: 80px;
      left: 20px;
      right: 0;
      padding-right: 20px;
      overflow: auto;
    }
  }
  .el-form {
    height: auto;
  }
}
</style>
